import { create } from "zustand";
import { persist } from "zustand/middleware";

const useStore = create(
  persist(
    (set) => ({

      user: null,
      setUser: (user) => set({ user }),

      role: null,
      setRole: (role) => set({ role }),

      permissions: [],
      setPermissions: (permissions) => set({ permissions }),

      clearUser: () => {
        set({ user: null });
        useStore.persist.clearStorage();
      },

      assigned: null,
      setAssigned: (assigned) => set({ assigned }),
      message: null,
      setMessage: (message) => set({ message }),
    }),
    { name: "user-storage" }
  )
);

export default useStore;
